/**
 * Photopea 通过地址栏 Hash 打开远程文件，格式示例：
 * https://www.photopea.com#{"files":["https://bucket.cos.region.myqcloud.com/path.jpg"]}
 * （不对整段 JSON 再做 encodeURIComponent，与官方文档示例一致；图片 URL 内勿含未转义 `"`）
 * @see https://www.photopea.com
 */
const PHOTOPEA_ORIGIN = 'https://www.photopea.com';

/** 是否为腾讯云 COS 公网直链（可直接给 Photopea 拉取，前提是桶 CORS 允许 photopea.com） */
export function isTencentCosPublicUrl(url: string): boolean {
  const u = String(url || '').trim();
  if (!/^https:\/\//i.test(u)) return false;
  return /\.cos\.[^/]+\.myqcloud\.com\//i.test(u) || /\.cos\.[^.]+\.myqcloud\.com\//i.test(u);
}

export function buildPhotopeaOpenUrl(publicImageUrls: string[]): string {
  const json = JSON.stringify({ files: publicImageUrls });
  return `${PHOTOPEA_ORIGIN}#${json}`;
}
